app.service('opinionForm',function(console, productCardConfig, validate, loading, log, captchaService, text) {
	var $self, $form, $opinionStars, $votingStars, $attributeNotes, $totalGrade, $yourGrade, $summary, $container;

	function loadForm(html) {
		$self.html(html);
		setElements();
		setEvents();
		if ($summary.length) {
			$.scrollTo($summary);
			$container.removeClass('adding-opinion');
			$container.addClass('opinion-added');
		} else {
			initGrade();
			parseBadWordsResponse();
			validate.task('opinion', function() {
				submit();
			});
		}
		loading.stop();
	}
	function loadSuccess(html){
		console.log('ZAŁADOWANIE FORMULARZA NOWEJ OPINII');
		loadForm(html);

		addOpinionCaptcha();
		
		var hash = document.location.hash;
		if (hash == '#opinionFormAdd') {
			$form.submit();
		}
		if (hash == '#opinionForm' || document.location.search.indexOf('mid=') > -1) {
			$.scrollTo($form);
		}
		if(!hash) {
			$.scrollTo($form);
		}
	}
	function loadError(){
		console.log('BŁĄD ŁADOWANIA FORMULARZA NOWEJ OPINII');
		$self.html('<div class="tab-error">Wystąpił błąd ładowania formularza. Prosimy spróbować później</div>');
	}
	function load() {
		var config=productCardConfig.getData();
		var data = {
			'product-link-name':config.linkName,
			preview:config.preview,
			mid: getUrlParameter('mid'),
			grade: getUrlParameter('grade')
		};
		$.ajax({
			url:'/product-opinion-form.ltr',
			cache:false,
			data: data,
			success: function(html) {
				loadSuccess(html, true);
			},
			error:function(){
				loadError();
			}
		});
	}
	function submitSuccess(html) {
		console.log('ODPOWIEDŹ NA WYSŁANIE FORMULARZA NOWEJ OPINII');
		loadForm(html);
		UA.pageInteraction('Opinie', 'Wysłano opinię');
		log.recommendationsForAWS({
			productPlu: productCardConfig.getData().plu,
			eventCategory: 'KP',
			eventAction: 'Opinie',
			eventLabel: 'Dodaj opinię'
		});

		addOpinionCaptcha();
	}
	function submitError(){
		console.log('BŁĄD WYSYŁANIA FORMULARZA NOWEJ OPINII');
		$self.html('<div class="tab-error">Wystąpił błąd wysyłania formularza. Prosimy spróbować później</div>');
	}
	function submit(){
		loading.start();
		var config = productCardConfig.getData();
		var data = {
			'product-link-name':config.linkName,
			mid: getUrlParameter('mid'),
			chandelier:parseInt(new Date().getTime()/987),
			grade: getUrlParameter('grade')
		};
		$form.ajaxSubmit({
			beforeSubmit: function (payload) {
				const opinion = payload.find(el => el.name == 'opinion');
				opinion.value = text.clean(opinion.value);
			},
			url: '/product-opinion-form.ltr',
			type: 'POST',
			cache: false,
			data: data,
			success: function(html) {
				submitSuccess(html);
			},
			error:function(){
				submitError();
			}
		});
	}
	function addOpinionCaptcha() {
		let $captcha = $self.find('[data-toggle="captcha"]');
		if ($captcha.length) {
			captchaService.load($captcha.attr('id'), $captcha.data('place'));
		}
	}
	function setOpinionStars() {
		var valid = 0;
		$attributeNotes.each(function() {
			if($(this).val() > 0) {
				valid++;
			}
		});
		$opinionStars.val(valid);

		if (valid === $attributeNotes.length) {
			calculateOpinionStars();
			if ($opinionStars.hasClass('error')) {
				$form.validate().element($opinionStars);
			}
		}
	}
	function calculateOpinionStars(){
		var grade=0;
		$attributeNotes.each(function(){
			grade += parseInt($(this).val());
		});
		if($attributeNotes.length){
			setGrade(Math.max(Math.ceil(grade/$attributeNotes.length),0));
		}
	}
	function setTotalGrade(value){
		setGrade(value);
	}
	function setGrade(value, grade) {
		var input, gradeItem;
		if (grade) {
			input = $('#grade'+grade);
		} else {
			input = $('#grade');
		}
		gradeItem = input.closest('.js-grade-item');
		gradeItem.removeClass('grade-'+(input.val()?input.val():"0"));
		gradeItem.addClass('grade-'+value);
		input.val(value);
		if (input.hasClass('error')) {
			$form.validate().element(input);
		}
		if (grade) {
			setOpinionStars();
		}
	}
	function initGrade() {
		$attributeNotes.each(function() {
			$(this).closest('.js-grade-item').addClass('grade-'+($(this).val()?$(this).val():"0"));
		});
		$yourGrade.closest('.js-grade-item').addClass('grade-'+$yourGrade.val());
		setOpinionStars();
	}
	function handlePromotionCheckboxes(isSelected) {
		var $unchecked = $('input[type="checkbox"]', $opinionPromotionsTerms).not(':checked');
		var $parentRow = $unchecked.closest('.opinion-promotion-row');
		if(isSelected) {
			$unchecked.attr('disabled', 'true');
			$parentRow.addClass('show-promotion-hint');
		} else {
			$unchecked.removeAttr('disabled');
			$parentRow.removeClass('show-promotion-hint');
		}
	}
	function parseBadWordsResponse() {
		$('.js-contains-bad-words').each(function() {
			$(this).val($(this).val().replace(/<span style="color:red">/g, '').replace(/<\/span>/g, ''));
		});
	}
	function getUrlParameter(name) {
		name = name.replace(/[\[]/, "\\\[").replace(/[\]]/, "\\\]");
		var regexS = "[\\?&]" + name + "=([^&#]*)";
		var regex = new RegExp(regexS);
		var results = regex.exec(window.location.href);
		if (results === null){
			return "";
		}else{
			return results[1];
		}
	}
	function setEvents() {
		$stars.on('click', function() {
			setGrade($(this).data('value'), $(this).data('grade'));
		});
		$totalGrade.on('click', function() {
			setTotalGrade($(this).data('value'));
		});
		if($opinionPromotionsCheckboxes.length > 1 ){
			$opinionPromotionsCheckboxes.on('change', function(e){
				handlePromotionCheckboxes(e.target.checked);
			});
		}
	}
	function setElements(){
		$form = $('form', $self);
		$opinionStars = $('#opinion-stars', $form);
		$stars = $('#opinion-form-grades .js-attribute-grade a', $form);
		$attributeNotes = $('#opinion-form-grades .js-attribute-grade input', $form);
		$yourGrade = $('#opinion-form-grades .js-your-grade input', $form);
		$totalGrade = $('#opinion-form-grades .js-your-grade a', $form);
		$summary = $('#opinion-summary', $self);
		$opinionPromotionsTerms = $('#opinion-promotions-terms', $self);
		$opinionPromotionsCheckboxes = $('.checkbox-css', $opinionPromotionsTerms);
		$container = $('#opinions');
	}
	function init(){
		$self = $('#add-opinion-form');
		load();
	}
	return {
		init:init
	};
});
